import React from 'react';
import Icon from '../AppIcon';

const StatusIndicator = ({ 
  status = 'pending', 
  type = 'enquiry', 
  size = 'default',
  showIcon = true,
  showText = true,
  className = ''
}) => {
  const statusConfig = {
    enquiry: {
      pending: {
        label: 'Pending',
        color: 'bg-warning text-warning-foreground',
        icon: 'Clock'
      },
      active: {
        label: 'Active',
        color: 'bg-primary text-primary-foreground',
        icon: 'Activity'
      },
      matched: {
        label: 'Matched',
        color: 'bg-success text-success-foreground',
        icon: 'CheckCircle'
      },
      completed: {
        label: 'Completed',
        color: 'bg-muted text-muted-foreground',
        icon: 'Check'
      },
      cancelled: {
        label: 'Cancelled',
        color: 'bg-destructive text-destructive-foreground',
        icon: 'X'
      }
    },
    agent: {
      pending: {
        label: 'Pending Verification',
        color: 'bg-warning text-warning-foreground',
        icon: 'Clock'
      },
      verified: {
        label: 'Verified',
        color: 'bg-success text-success-foreground',
        icon: 'Shield'
      },
      rejected: {
        label: 'Rejected',
        color: 'bg-destructive text-destructive-foreground',
        icon: 'ShieldX'
      },
      suspended: {
        label: 'Suspended',
        color: 'bg-error text-error-foreground',
        icon: 'AlertTriangle'
      }
    },
    message: {
      unread: {
        label: 'Unread',
        color: 'bg-accent text-accent-foreground',
        icon: 'Mail'
      },
      read: {
        label: 'Read',
        color: 'bg-muted text-muted-foreground',
        icon: 'MailOpen'
      }
    }
  };

  const sizeConfig = {
    sm: {
      padding: 'px-2 py-1',
      text: 'text-xs',
      iconSize: 12,
      gap: 'space-x-1'
    },
    default: {
      padding: 'px-3 py-1.5',
      text: 'text-sm',
      iconSize: 14,
      gap: 'space-x-1.5'
    },
    lg: {
      padding: 'px-4 py-2',
      text: 'text-base',
      iconSize: 16,
      gap: 'space-x-2'
    }
  };

  const config = statusConfig?.[type]?.[status];
  const sizeStyles = sizeConfig?.[size];

  if (!config) {
    return null;
  }

  return (
    <span 
      className={`
        inline-flex items-center font-medium rounded-full
        ${config?.color}
        ${sizeStyles?.padding}
        ${sizeStyles?.text}
        ${showIcon && showText ? sizeStyles?.gap : ''}
        ${className}
      `}
    >
      {showIcon && (
        <Icon 
          name={config?.icon} 
          size={sizeStyles?.iconSize}
          className="flex-shrink-0"
        />
      )}
      {showText && (
        <span>{config?.label}</span>
      )}
    </span>
  );
};

export default StatusIndicator;